const details = {
    sustainability: {
        zero_waste: 'Zero-Waste',
        biodegradable: 'Biodegradable',
        natural_materials: 'Natural Materials',
    },
    transparency: {
        open_supply_chain: "Open Supply Chain",
        b_corp: "B-Corporation",
        fairtrade: 'Fairtrade',
        coop_produced: 'Co-Op Produced'
    },
    allergens: {
        milk: "Milk",
        lactose: "Lactose",
        eggs: "Eggs",
        treenuts: "Tree Nuts",
        peanuts: "Peanuts",
        sesame: "Sesame",
        wheat: "Wheat",
        gluten: "Gluten",
        fish: "Fish",
        shellfish: "Shellfish",
        soy: "Soy",
        sulfites: "Sulfites",
    },
    dietary: {
        vegetarian: "Vegetarian",
        vegan: "Vegan",
        keto: "Ketogenic",
        organic: "Organic"
    }
}

export default details
